import { SVGProps } from 'react';

import BrainHealth from './assets/brain-health.svg?react';
import Ellipse1Desktop from './assets/ellipse-1-desktop.svg?react';
import Ellipse1Mobile from './assets/ellipse-1-mobile.svg?react';
import Ellipse2Desktop from './assets/ellipse-2-desktop.svg?react';
import Ellipse2Mobile from './assets/ellipse-2-mobile.svg?react';
import HeartInHands from './assets/heart-in-hands.svg?react';
import Man1Locked from './assets/man-1-locked.svg?react';
import Man1 from './assets/man-1.svg?react';
import Man2Locked from './assets/man-2-locked.svg?react';
import Man2 from './assets/man-2.svg?react';
import Man3Locked from './assets/man-3-locked.svg?react';
import Man3 from './assets/man-3.svg?react';
import ManPointing from './assets/man-pointing.svg?react';
import ManSitting from './assets/man-sitting.svg?react';
import NotFound from './assets/not-found.svg?react';
import SoftwareTester from './assets/software-tester.svg?react';
import Toc1 from './assets/toc-1.svg?react';
import Toc2 from './assets/toc-2.svg?react';
import Toc3 from './assets/toc-3.svg?react';
import Toc4 from './assets/toc-4.svg?react';
import Toc5 from './assets/toc-5.svg?react';
import Woman1Locked from './assets/woman-1-locked.svg?react';
import Woman1 from './assets/woman-1.svg?react';
import Woman2Locked from './assets/woman-2-locked.svg?react';
import Woman2 from './assets/woman-2.svg?react';
import Woman3Locked from './assets/woman-3-locked.svg?react';
import Woman3 from './assets/woman-3.svg?react';
import Woman4 from './assets/woman-4.svg?react';
import WomanJumping from './assets/woman-jumping.svg?react';
import WomanOptOut from './assets/woman-opt-out.svg?react';
import WomanPuzzle from './assets/woman-puzzle.svg?react';
import WomanSittingOnPhone from './assets/woman-sitting-on-phone.svg?react';
import WomanSitting from './assets/woman-sitting.svg?react';
import WomanStanding from './assets/woman-standing.svg?react';
import WomanWip from './assets/woman-wip.svg?react';

const Illustration = ({ name, className, size, ...props }: IllustrationProps) => {
  const IllustrationComponent = illustrations[name];

  return <IllustrationComponent className={className} height={size} width={size} {...props} />;
};

type IllustrationName = keyof typeof illustrations;

type IllustrationProps = {
  readonly name: IllustrationName;
  readonly className?: string;
  readonly size?: number | string;
} & Omit<SVGProps<SVGSVGElement>, 'name'>;

const illustrations = {
  BrainHealth,
  Ellipse1Desktop,
  Ellipse1Mobile,
  Ellipse2Desktop,
  Ellipse2Mobile,
  HeartInHands,
  Man1,
  Man1Locked,
  Man2,
  Man2Locked,
  Man3,
  Man3Locked,
  ManPointing,
  ManSitting,
  NotFound,
  SoftwareTester,
  Toc1,
  Toc2,
  Toc3,
  Toc4,
  Toc5,
  Woman1,
  Woman1Locked,
  Woman2,
  Woman2Locked,
  Woman3,
  Woman3Locked,
  Woman4,
  WomanJumping,
  WomanOptOut,
  WomanPuzzle,
  WomanSitting,
  WomanSittingOnPhone,
  WomanStanding,
  WomanWip,
} as const;

export {
  BrainHealth,
  Ellipse1Desktop,
  Ellipse1Mobile,
  Ellipse2Desktop,
  Ellipse2Mobile,
  HeartInHands,
  Illustration,
  illustrations,
  Man1,
  Man1Locked,
  Man2,
  Man2Locked,
  Man3,
  Man3Locked,
  ManPointing,
  ManSitting,
  NotFound,
  SoftwareTester,
  Toc1,
  Toc2,
  Toc3,
  Toc4,
  Toc5,
  Woman1,
  Woman1Locked,
  Woman2,
  Woman2Locked,
  Woman3,
  Woman3Locked,
  Woman4,
  WomanJumping,
  WomanOptOut,
  WomanPuzzle,
  WomanSitting,
  WomanSittingOnPhone,
  WomanStanding,
  WomanWip,
};
export type { IllustrationName, IllustrationProps };
